import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from './../api.service';
import { CommonService } from '../services/common.service';
import { ChangeDetectorRef, Inject } from '@angular/core';
import { formatDate, DatePipe, DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { SetAcctStartDateComponent } from '../set-acct-start-date/set-acct-start-date.component';

@Component({
  selector: 'app-ledger-entry',
  templateUrl: './ledger-entry.component.html',
  styleUrls: ['./ledger-entry.component.scss']
})
export class LedgerEntryComponent implements OnInit {

  constructor(private SpinnerService: NgxSpinnerService, private modalService: NgbModal, private apiService: APIService, public CmnService: CommonService, @Inject(DOCUMENT) private document: Document) { 
    this.window = this.document.defaultView;
  }

  openFromWindowPopup: any = this.CmnService.GetParam('S');
  modalReference: any;
  newLedger = {
    accountHead: '0',
    ledgerName: '',
    openingBal: 0,
    curr: 'Cr',
    id: 0,
    type: 0,
    isCustomer: false,
    customerId: 0,
    customerName: '',
    isSupplier: false,
    supplierId: 0,
    supplierName: '',
    isBank: false,
    isCash: false,
    isEmployee: false,
  };

  bank = {
    name: '',
    branch: '',
    accNo: '',
    ifsc: '',
    bankID: 0
  };

  fromDate: any;
  toDate: any;
  selectedFY: any;
  window: any = '';

  isShowZeroBal: boolean = false;
  isClosSettingShow = false

  heads: any = [];
  jarvisData: any = [];
  agencyData: any = [];
  customers: any = [];
  connections: any = [];
  suppliers: any = [];
  ledgersData: any;
  ledger: any = [];
  financialYears: any = [];
  compRules = {
    isB2C: false
  };

  ngOnInit(): void {    
    resizeTo(620, 390);
    if(this.openFromWindowPopup == 1){
      this.isClosSettingShow = true;
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      this.compRules.isB2C = this.agencyData[0].IsB2C;
    }

    var ledger = this.apiService.getCookie('Ledger');
    if (ledger) {
      this.ledgersData = JSON.parse(ledger);
    }
    this.financialYears = this.checkFinancialYear(new Date("2015"), new Date());
    this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    let currentDate = new Date();
    this.fn_Set_FinancialYear(currentDate);
  
  }

  //Functions
  getData(id: number) {
    /*let accountsDate: any = this.apiService.getCookie("AccountsDates");
    if (accountsDate) {
      accountsDate = JSON.parse(accountsDate);
      if (accountsDate.length > 0) {
        this.fromDate = accountsDate[0].fdt;
        this.toDate = accountsDate[0].tdt;
      }
    }*/

    let data = [{
      fromDT: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
      toDT: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#")
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 1,
      data: JSON.stringify(data)
    }];

    this.SpinnerService.show();
    // Get Ledgers and Vouchers
    this.apiService.getData(myParams, this.successResp.bind(this, id), this.failureResp.bind(this));

    // Get Relatives - Indexed DB
    this.getHRels();
  }

  

  //failureResp - failure handler
  failureResp(res: any) {
    this.SpinnerService.hide();
    if (res.error) {

    }
    else {
      alert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(id: number, res: any) {
    this.SpinnerService.hide();
    if (res.error) {
      this.SpinnerService.hide();
    }
    else {
      if (res) {
        let isHideZero = this.apiService.getCookie("hideZero");
        // if(isHideZero){
        //   this.hideZeroLevelLdgr = isHideZero == "true" ? true : false;
        // }

        this.SpinnerService.hide();
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          var data = reponseData;
          this.heads = data.Table2;
          console.log(this.heads)
          this.ledger = data.Table1;
          // console.log("Heads", this.heads);

          //console.log(this.heads)
          this.apiService.setCookie("Heads", JSON.stringify(this.heads));

          if (this.heads.length == 0) {
            alert('Please initialize your Accounts setup.');
            window.location.href = "../../main.html";
            return;
          }

          // if (this.ledger.length > 0) {
          //   this.accountsComponent.isShowVoucherBtn = true;
          //   if (this.isFav == true) {
          //     //this.accountsComponent.ledgers = this.ledger;
          //   }
          // }

         // this.appService.getFavLedger(this.ledger);

          this.apiService.setCookie("Ledger", JSON.stringify(this.ledger))

          let enteredLedgers: Array<any> = $.grep(this.ledger, (x: any) => { return x.LedgerName != 'Profit & Loss A/c' })
          if (enteredLedgers.length == 0) {
            this.openAskAcctStartDT();
          }
         
        }
      }
    }
  }

  ledgerType(id: any) {
    //Select ledger type in ledger Entry/Edit modal
    this.newLedger.customerId = 0;
    this.newLedger.supplierId = 0;

    this.newLedger.isCustomer = false;
    this.newLedger.isSupplier = false;
    this.newLedger.isBank = false;
    this.newLedger.isCash = false;
    this.newLedger.isEmployee = false;

    this.bank = {
      name: '',
      branch: '',
      accNo: '',
      ifsc: '',
      bankID: 0
    };

    this.newLedger.type = id;
    id == 1 ? this.newLedger.isCustomer = true : id == 2 ? this.newLedger.isSupplier = true : id == 3 ? this.newLedger.isBank = true : id == 4 ? this.newLedger.isCash = true : this.newLedger.isEmployee = true;

    if(this.newLedger.isBank == true){
      resizeTo(620, 570);
    }
    else if (this.newLedger.type != 0) {
      resizeTo(620, 430);
    }
    else {
      resizeTo(620, 390);
    }
  }

  //qty with prcn
  onlyNumberAlllow = () => {
    this.newLedger.openingBal = this.CmnService.PrecisionwiseValue(this.newLedger.openingBal, 2)
  }

  saveLedger() {
    let tmpLedger = $.grep(this.ledger, (e: any) => { return (e.LedgerName == this.newLedger.ledgerName) });

    if (this.newLedger.accountHead == '0') {
      alert('Please select group head.')
    }

    else if (this.newLedger.ledgerName == '') {
      alert('Please enter ledger name.')
    }

    else if (tmpLedger.length > 0) {
      alert('Duplicate ledger name found.');
    }

    else if (this.newLedger.isCustomer && this.newLedger.customerId == 0) {
      alert('Please select customer.');
    }

    else if (this.newLedger.isSupplier && this.newLedger.supplierId == 0) {
      alert('Please select supplier.');
    }

    else if (this.newLedger.isBank && (!this.bank.name)) {
      alert('Please enter a bank name.');
      return;
    }

    else if (this.newLedger.isBank && (!this.bank.branch)) {
      alert('Please enter a branch.');
      return;
    }

    else if (this.newLedger.isBank && (!this.bank.ifsc)) {
      alert('Please enter a IFSC code.');
      return;
    }

    else if (this.newLedger.isBank && (!this.bank.ifsc)) {
      alert('Please enter an account number.');
      return;
    }
    else {
      let head = $.grep(this.heads, (e: any) => { return (e.HeadID == Number(this.newLedger.accountHead)) });
      let cust = $.grep(this.customers, (e: any) => { return (e.RI == Number(this.newLedger.customerId)) });
      let supp = $.grep(this.suppliers, (e: any) => { return (e.RI == Number(this.newLedger.supplierId)) });
      let obj = [{
        ledgerName: this.newLedger.ledgerName,
        headID: head[0].HeadID,
        openingBal: this.newLedger.curr == 'Cr' ? '-' + this.newLedger.openingBal : this.newLedger.openingBal,
        userID: 0,
        isCustomer: this.newLedger.isCustomer,
        isSupplier: this.newLedger.isSupplier,
        isBank: this.newLedger.isBank,
        isCash: this.newLedger.isCash,
        isEmployee: this.newLedger.isEmployee,
        relID: this.newLedger.isCustomer ? cust[0].RI : this.newLedger.isSupplier ? supp[0].RI : 0,
        relAgencyID: this.newLedger.isCustomer ? cust[0].RAID : this.newLedger.isSupplier ? supp[0].RAID : 0,
        bankName: this.bank.name ? this.bank.name : '',
        branch: this.bank.branch ? this.bank.branch : '',
        IFSC: this.bank.ifsc ? this.bank.ifsc : '',
        accountNo: this.bank.accNo ? this.bank.accNo : ''
      }];
      this.sendChanges(obj, 2, 'set');
    }
  }

  sendChanges(obj: any, moduleId: number, actionType: string) {
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: actionType,
      moduleID: moduleId,
      data: JSON.stringify(obj)
    }];
    this.SpinnerService.show();
    this.apiService.sendChange(myParams, this.successGroupEntry.bind(this), this.failureResp.bind(this));
    if (this.modalReference) {
      this.modalReference.close();
    }

    // if (moduleId == 1 && actionType == 'edit') {
    //   this.tree[this.tree.length - 1].headName = this.newGroup.newGroupName
    // }

    //this.resetNewGroup();
    //this.resetNewLedger();

  }

  successGroupEntry(res: any) {
    this.SpinnerService.hide();
    this.window = this.document.defaultView;
    let issuccess: boolean = false;
    if (res.error) {
      issuccess = false;
    }
    else {
      alert(res.message);
      issuccess = true;
      if(issuccess) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode != -1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          let ledgerID = reponseData.Table[0].LedgerID;
          this.window.ledgerID = ledgerID;
          this.window.isSuccessLedger = 1;
          this.removeCookie("LdgrsForVhcr");
        }

        // this.window.ledgerID = res
        // this.window.close();
        this.getBankData();
      }
    }
  }

  removeCookie(cName: string) {
    if (cName) {
      localStorage.removeItem(cName);
    }
  }

  checkFinancialYear(date1: any, date2: any) {
    let financialYear = [];
    let fYear = new Date(date1).getFullYear();
    let lYear = new Date(date2).getFullYear();
    let toValueCheck = lYear;
    if (fYear == lYear) {
      let fMonth = new Date(date1).getMonth() + 1;
      if (fMonth < 4) {
        fYear = fYear - 1;
      }
      else {
        fYear = fYear;
      }
      let lMnth = new Date(date2).getMonth() + 1;
      if (lMnth > 3) {
        toValueCheck = lYear + 1;
      }

    }
    else {
      let fMonth = new Date(date1).getMonth() + 1;
      if (fMonth < 4) {
        fYear = fYear - 1;
      }
      else {
        fYear = fYear;
      }

      let lMnth = new Date(date2).getMonth() + 1;
      if (lMnth > 3) {
        toValueCheck = lYear + 1;
      }
    }


    for (var i = fYear; i < toValueCheck; i++) {
      financialYear.push({ 'FY': this.getCurrentFinancialYear('1-Apr-' + i) })
    }
    return financialYear;
  }

  getCurrentFinancialYear(fromDT: any) {
    var fiscalyear = "";
    var today = new Date(fromDT);
    if ((today.getMonth() + 1) < 4) {
      fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
    } else {
      fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
    }
    return fiscalyear
  }

  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      this.toDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      this.toDate = new Date(Year + "/03/31");
    }

    let ledgersCookie: any = this.apiService.getCookie('Ledger');
    let headsCookie: any = this.apiService.getCookie('Heads');
    if (!ledgersCookie || !headsCookie) {
      this.getData(1);
    } 
    else {
      let heads = JSON.parse(headsCookie);
      let ledgers = JSON.parse(ledgersCookie);

      let enteredLedgers: Array<any> = $.grep(ledgers, (x: any) => { return x.LedgerName != 'Profit & Loss A/c' })

      if (enteredLedgers.length == 0) {
        this.openAskAcctStartDT();
      }
      if (ledgers && ledgers.length > 0) {
        this.ledger = ledgers;
      }
      if (heads && heads.length > 0) {
        this.heads = heads;
      }

      // Get Relatives - Indexed DB
      this.getHRels();
    }
    //this.getData();
  }

  getHRels () {
    //Get H from IDB
    var self = this;
    var tblH = this.apiService.getIDB('H', function(dataList: any){
      if(dataList){ 
        self.connections = dataList;
        self.customers = $.grep(self.connections, (e: any) => { return (e.C == true) });
        self.suppliers = $.grep(self.connections, (e: any) => { return (e.S == true) });      
      }
      self.isShowZeroBal = false;
    })
  }

  //customerChange() - Customer Change
  customerChange() {

    let tmpCustList: Array<any> = this.customers.filter((x: any) => x.Cmp == this.newLedger.customerName);
    if (tmpCustList.length > 0) {
      this.newLedger.customerId = tmpCustList[0].RI;
    }
  }

  //supplierChange() - Supplier Change
  supplierChange() {
    let tmpCustList: Array<any> = this.suppliers.filter((x: any) => x.Cmp == this.newLedger.supplierName);
    if (tmpCustList.length > 0) {
      this.newLedger.supplierId = tmpCustList[0].RI;
    }
  }

  // getBankData() - get all getBankData databse
  getBankData(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: ''
    }];
    this.apiService.getData(myParams, this.successRespBankData.bind(this), this.failureRespBankData.bind(this));
    }

     //successResp - success  get handler
     successRespBankData(res: any) {
      if (res.error) {
      }
      else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table2) {
                let tempData: any = [];
                console.log('bank data', reponseData);
                tempData = reponseData.Table2[0].BankLedgers;
               // console.log('bank data', tempData);
               let bankList = this.apiService.getCookie('ERP_Cfg');
               if (bankList) {
                 bankList = JSON.parse(bankList);
                 let bankUpdatedData: any = [];  
                bankUpdatedData = bankList; 
                 if (bankUpdatedData.length > 0) {
                  bankUpdatedData[0].BankLedgers = tempData;
                 }
                 this.apiService.setCookie('ERP_Cfg', JSON.stringify(bankUpdatedData));
               }
             }
          }
      }
  }

  //failureResp - failure handler
  failureRespBankData(res: any) {
    if (res.error) {
    }
  }

  // openAskAcctStartDT() - Open modal for setting account start date.
	openAskAcctStartDT() {
		this.modalReference = this.modalService.open(SetAcctStartDateComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'acct-start-date-mdl', backdrop: 'static', keyboard: false });
		this.modalReference.componentInstance.setAcctDTModalRef = this.modalReference;
        this.modalReference.result.then((result: any) => {
            if (result == 'success') {
                // Success                
            }
		}, (reason: any) => {
		});
	}

  
}
